import type React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import type { FileData, MultiRecordingFileData } from "@/services/files";
import { CustomCollapsibleItem } from "../custom-collapsible-item";

interface TranscriptionsCardProps {
  file: FileData | null;
  multiRecordingFiles: MultiRecordingFileData[];
  expandedItems: number[];
  toggleExpanded: (id: number) => void;
}

export const TranscriptionsCard: React.FC<TranscriptionsCardProps> = ({
  file,
  multiRecordingFiles,
  expandedItems,
  toggleExpanded,
}) => {
  const { t } = useTranslation();

  return (
    <Card className="mt-6">
      <CardHeader className="bg-grey-white rounded-t-lg p-0">
        <CardTitle className="text-lg font-bold p-6">
          {t("visit.transcriptions")}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6 rounded-b-md">
        {file ? (
          <CustomCollapsibleItem
            content={<p>{file.transcription}</p>}
            expanded={expandedItems.includes(file.id)}
            id={file.id}
            title={
              <h3 className="text-lg font-bold">{t("visit.recording")} #1</h3>
            }
            onToggle={() => {
              toggleExpanded(file.id);
            }}
          />
        ) : (
          <div className="flex items-center justify-center py-4">
            <div className="w-5 h-5 border-2 border-t-primary border-primary/50 rounded-full animate-spin" />
          </div>
        )}
      </CardContent>
      {multiRecordingFiles.map((record, index) => (
        <CardContent key={record.id} className="p-6 border-t">
          {record.status.toLowerCase() === "processing" ? (
            <div className="flex items-center justify-center py-4">
              <div className="w-5 h-5 border-2 border-t-primary border-primary/50 rounded-full animate-spin" />
            </div>
          ) : (
            <CustomCollapsibleItem
              content={<p>{record.transcription}</p>}
              expanded={expandedItems.includes(record.id)}
              id={record.id}
              title={
                <h3 className="text-lg font-bold">
                  {t("visit.recording")} #{index + 2}
                </h3>
              }
              onToggle={() => {
                toggleExpanded(record.id);
              }}
            />
          )}
        </CardContent>
      ))}
    </Card>
  );
};
